/*
 * Feed do Instagram via Behold.
 *
 * O Liquid não faz requisição HTTP, então o feed só pode ser buscado aqui.
 * A grade já vem preenchida do servidor (posts manuais ou esqueletos); este
 * script troca o conteúdo quando o JSON chega. Se algo falhar — rede, formato,
 * feed vazio — ele não mexe em nada e o que veio do servidor continua na tela.
 *
 * O markup do card NÃO é escrito aqui. A seção renderiza um card vazio dentro
 * de <template data-feed-molde> com os ganchos data-feed-*, e este arquivo
 * apenas clona e preenche. As classes do card vivem só no yasy-social-card.
 */
(function () {
  'use strict';

  var VALIDADE = 15 * 60 * 1000; // 15 min de cache por aba
  var LEGENDA_MAX = 140;

  function cacheLer(chave) {
    try {
      var bruto = sessionStorage.getItem(chave);
      if (!bruto) return null;
      var guardado = JSON.parse(bruto);
      if (Date.now() - guardado.quando > VALIDADE) return null;
      return guardado.dados;
    } catch (e) {
      return null;
    }
  }

  function cacheGravar(chave, dados) {
    try {
      sessionStorage.setItem(chave, JSON.stringify({ quando: Date.now(), dados: dados }));
    } catch (e) {
      /* modo privado ou cota cheia: seguir sem cache */
    }
  }

  function buscar(url) {
    var chave = 'yasy-feed:' + url;
    var guardado = cacheLer(chave);
    if (guardado) return Promise.resolve(guardado);

    return fetch(url, { cache: 'default' })
      .then(function (r) {
        if (!r.ok) throw new Error('feed respondeu ' + r.status);
        return r.json();
      })
      .then(function (dados) {
        cacheGravar(chave, dados);
        return dados;
      });
  }

  /* O Behold entrega small/medium/large/full com largura declarada; viram um
     srcset para o navegador escolher conforme a coluna da grade. */
  function montarSrcset(sizes) {
    if (!sizes) return null;
    var partes = [];
    ['small', 'medium', 'large', 'full'].forEach(function (nome) {
      var s = sizes[nome];
      if (s && s.mediaUrl && s.width) partes.push(s.mediaUrl + ' ' + s.width + 'w');
    });
    return partes.length ? partes.join(', ') : null;
  }

  function melhorImagem(post) {
    var s = post.sizes || {};
    var escolha = s.medium || s.large || s.small || s.full;
    return (escolha && escolha.mediaUrl) || post.mediaUrl || null;
  }

  function resumir(texto) {
    if (!texto) return '';
    var limpo = String(texto).replace(/\s+/g, ' ').trim();
    if (limpo.length <= LEGENDA_MAX) return limpo;
    return limpo.slice(0, LEGENDA_MAX - 1).replace(/\s+\S*$/, '') + '…';
  }

  function montarCard(post, molde, mostrarLegenda, perfil) {
    var no = molde.content.firstElementChild.cloneNode(true);
    var link = no.matches('[data-feed-link]') ? no : no.querySelector('[data-feed-link]');
    var img = no.querySelector('[data-feed-img]');
    var src = melhorImagem(post);
    if (!link || !img || !src) return null;

    link.href = post.permalink || '#';

    img.src = src;
    var srcset = montarSrcset(post.sizes);
    if (srcset) img.srcset = srcset;

    var legenda = resumir(post.prunedCaption || post.caption);
    /* O alt descreve a imagem para quem não a vê; sem legenda, ao menos diz de
       quem é a publicação em vez de ficar vazio. */
    img.alt = legenda || ('Publicação de @' + (perfil || 'yasy'));

    var faixa = no.querySelector('[data-feed-legenda]');
    var texto = no.querySelector('[data-feed-texto]');
    if (faixa && texto && mostrarLegenda && legenda) {
      texto.textContent = legenda;
      faixa.hidden = false;
    } else if (faixa) {
      faixa.remove();
    }

    return no;
  }

  /* Quando o feed falha, o que fica na tela depende do que o servidor pôs lá:
     havendo posts manuais, eles seguem valendo como conteúdo. Havendo só
     esqueletos, a grade some — esqueleto que nunca resolve é pior que nada, e
     a seção continua de pé com chamada, perfil e botão. */
  function desistir(grade, secao) {
    secao.setAttribute('data-feed-estado', 'erro');
    if (grade.hasAttribute('data-feed-so-esqueleto')) grade.remove();
  }

  function preencher(secao) {
    var url = secao.getAttribute('data-feed-url');
    var grade = secao.querySelector('[data-feed-grade]');
    var molde = secao.querySelector('[data-feed-molde]');
    if (!url || !grade || !molde) return;

    var qtd = parseInt(secao.getAttribute('data-feed-qtd'), 10) || 4;
    var mostrarLegenda = secao.getAttribute('data-feed-legendas') === 'true';

    buscar(url)
      .then(function (dados) {
        var posts = (dados && dados.posts) || [];
        if (!posts.length) return;

        var pedaco = document.createDocumentFragment();
        var montados = 0;
        for (var i = 0; i < posts.length && montados < qtd; i++) {
          var card = montarCard(posts[i], molde, mostrarLegenda, dados.username);
          if (card) {
            pedaco.appendChild(card);
            montados++;
          }
        }
        /* Só troca se houver o que mostrar — melhor o conteúdo do servidor que
           uma grade vazia. */
        if (!montados) {
          desistir(grade, secao);
          return;
        }

        grade.replaceChildren(pedaco);
        secao.setAttribute('data-feed-estado', 'pronto');
      })
      .catch(function (erro) {
        desistir(grade, secao);
        console.warn('[yasy] feed do Instagram indisponível:', erro.message);
      });
  }

  function iniciar() {
    var secoes = document.querySelectorAll('[data-yasy-feed]');
    if (!secoes.length) return;

    /* A seção fica no pé da página. Buscar só quando ela se aproxima da tela
       evita uma requisição que a maioria das visitas nunca precisaria. */
    if (typeof IntersectionObserver === 'undefined') {
      Array.prototype.forEach.call(secoes, preencher);
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        observador.unobserve(entrada.target);
        preencher(entrada.target);
      });
    }, { rootMargin: '400px 0px' });

    Array.prototype.forEach.call(secoes, function (s) { observador.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
